module.exports = __webpack_public_path__ + "static/image2-cdafd8e01c9a399f30a8198cc1fe913a.png";